import DateFns from 'date-fns';

const dateFormat = function (dates) {
  let patternDate = dates.map(item => {
    let isoDate = item.administrateDate;

    return {
      date: DateFns.format(isoDate, 'DD/MM/YYYY'),
      time: DateFns.format(isoDate, 'HH:mm')
    };
  });

  return patternDate;
};

export default dateFormat;
